import { useSprings, animated } from '@react-spring/web';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import useMeasure from 'react-use-measure';
const StyledSlider = styled(animated.div) `
  width: 100%;
  height: 100%;
  position: absolute;
  display: block;
`;
const StyledCarousel = styled.div `
  width: 100%;
  height: 500px;
  position: relative;
  overflow: hidden;
`;
export const Carousel = function (props) {
    var _a;
    const [ref, { width }] = useMeasure();
    const controlled = 'index' in props;
    const index = useRef(props.index || 0);
    const path = useRef({});
    const children = React.Children.toArray(props.children);
    const len = children.length || ((_a = props.dataSource) === null || _a === void 0 ? void 0 : _a.length) || 0;
    const total = len + (props.infinite ? len : 0);
    new Array(total).fill(0).forEach((_page, i) => {
        path.current[i] = {
            prev: i - index.current,
            next: i - 1 - index.current, // -1  0   1   2
        };
    });
    const [styles, api] = useSprings(total, (i) => ({
        x: i * width,
        display: 'block',
    }), [width]);
    let dir = 1;
    const handleCommonSlide = () => {
        index.current += dir;
        if (index.current === len - 1) {
            if (props.reverse) {
                dir = -1;
            }
            else {
                dir = 0;
            }
        }
        else if (index.current === 0) {
            if (props.reverse) {
                dir = 1;
            }
            else {
                dir = 0;
            }
        }
        api.start((i) => {
            if (i < index.current - 1 || i > index.current + 1) {
                return { display: 'none' };
            }
            const x = (i - index.current) * width;
            return { x, display: 'block' };
        });
    };
    const handleInfSlide = () => {
        api.start((i) => {
            let immediate = false;
            let display = 'block';
            if (Math.abs(path.current[i].prev - path.current[i].next) > 1) {
                immediate = true;
                display = 'none';
            }
            path.current[i].prev = path.current[i].next;
            const x = path.current[i].next * width;
            path.current[i].next -= 1;
            if (path.current[i].next === -2) {
                path.current[i].next += total;
            }
            return { x, display, immediate };
        });
    };
    useEffect(() => {
        if (!props.auto || !width || controlled) {
            return;
        }
        const callback = props.reverse ? handleCommonSlide : handleInfSlide;
        const timer = setInterval(callback, 2000);
        return () => clearInterval(timer);
    }, [props.auto, width, controlled]);
    useEffect(() => {
        var _a;
        if (!controlled) {
            return;
        }
        index.current = (_a = props.index) !== null && _a !== void 0 ? _a : 0;
        api.start((i) => {
            if (i < index.current - 1 || i > index.current + 1) {
                return { display: 'none' };
            }
            const x = (i - index.current) * width;
            return { x, display: 'block' };
        });
    }, [controlled, props.index]);
    return (React.createElement(StyledCarousel, { "data-role": "carousel", ref: ref }, styles.map(({ x, display }, i) => {
        var _a, _b;
        return (React.createElement(StyledSlider, { key: i, style: { x, display, zIndex: total - i } },
            React.createElement(animated.div, { style: { width: '100%', height: '100%' } }, props.dataSource ? (_a = props.renderSlider) === null || _a === void 0 ? void 0 : _a.call(props, (_b = props.dataSource) === null || _b === void 0 ? void 0 : _b[i]) : children[i])));
    })));
};
const StyledCarouselSlider = styled.div `
  width: 100%;
  height: 100%;
`;
export const CarouselSlider = (props) => {
    return (React.createElement(StyledCarouselSlider, { "data-role": "carousel-slider", style: props.style, className: props.className }, props.children));
};
